import React, { useState } from "react";
import PropTypes from "prop-types";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { IconButton } from "@mui/material";
import Translate from "orion-components/i18n/Translate";
import { canManageByApplication } from "orion-components/Profiles/Selectors";
import { useSelector } from "react-redux";

const getStyles = () => ({
	container: { fontSize: 12, width: "100%", height: "100%", border: "1px dashed #606060" },
	alignContentCenter: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100%"
	},
	widthFifty: {
		width: "50%"
	},
	addCameras: {
		width: "50%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center"
	},
	addButton: { width: 20, height: 20 }
});

const EmptySlot = ({ camera, AddCameraToClusterDialog, canAddCameras, rows, columns, currentCol, currentRow }) => {
	const [openDialog, setOpenDialog] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [styles, setStyles] = useState(getStyles());
	const canManage = useSelector((state) => canManageByApplication(state, "camera-wall-app", "manage"));

	const closeDialog = () => {
		setOpenDialog(false);
	};

	return (
		<div style={styles.container}>
			{camera === "Not available" ? (
				<div style={styles.alignContentCenter}>
					<div className="camera-emptySlotLabel" style={styles.widthFifty} data-testid="orion-components-shared-components-camera-clusters-empty-slot-div">
						<Translate value="global.sharedComponents.cameraClustersGrid.components.cameraMissing" />
					</div>
				</div>
			) : (
				<div style={styles.alignContentCenter}>
					{canAddCameras && canManage && (
						<div style={styles.addCameras}>
							<IconButton
								style={styles.addButton}
								onClick={() => {
									setOpenDialog(true);
								}} data-testid="orion-components-shared-components-camera-clusters-empty-slot-icon-button"
							>
								<AddCircleIcon />
							</IconButton>

							<div className="camera-emptySlotLabel" data-testid="orion-components-shared-components-camera-clusters-empty-slot-div-2">
								<Translate value="videoWall.cameraSlot.components.emptySlot.addCameras" />
							</div>
						</div>
					)}
					{!canAddCameras && (
						<div className="camera-emptySlotLabel" style={styles.widthFifty} data-testid="orion-components-shared-components-camera-clusters-empty-slot-div-3">
							<Translate value="global.sharedComponents.cameraClustersGrid.components.noCameraAssigned" />
						</div>
					)}
				</div>
			)}
			{canAddCameras && (
				<AddCameraToClusterDialog
					open={openDialog}
					rows={rows}
					columns={columns}
					currentCol={currentCol}
					currentRow={currentRow}
					closeDialog={closeDialog}
				/>
			)}
		</div>
	);
};

EmptySlot.propTypes = {
	currentCol: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	currentRow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	columns: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	camera: PropTypes.any,
	AddCameraToClusterDialog: PropTypes.any,
	canAddCameras: PropTypes.bool
};
EmptySlot.defaultProps = {
	AddCameraToClusterDialog: () => {
		return <></>;
	},
	canAddCameras: false
};

export default EmptySlot;
